// Chat emoticons: the typed codes and the emoji.png faces drawn for them (tools/generators/generate_emoji.py).
// Pure (no Pixi), so it is tested in Node.
export const EMOJI: Readonly<Record<string, string>> = {
  ':)': 'smile', ':(': 'sad', ':D': 'grin', ':3': 'cat', ':O': 'shock', ':o': 'surprise', ':P': 'tongue', ':$': 'blush',
  ':@': 'angry', ':H': 'cool', 'o.o': 'stare', 'XD': 'laugh', ':/': 'unsure', ':S': 'confused', ':^)': 'smug',
};
/** Codes longest first, so ":^)" wins over anything shorter at the same place. */
const CODES = Object.keys(EMOJI).sort((a, b) => b.length - a.length);

export type TextPart = string | { emoji: string };

/** Splits text into plain runs and emoji. A code counts only at the start or after a space, and not followed by a
 *  letter or digit, so "10:30" and ":Dave" stay text. */
export function splitEmoji(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let run = '';
  for (let i = 0; i < text.length; i++) {
    const code = i === 0 || /\s/.test(text[i - 1])
      ? CODES.find(c => text.startsWith(c, i) && !/[A-Za-z0-9]/.test(text[i + c.length] ?? '')) : undefined;
    if (code) {
      if (run) parts.push(run);
      parts.push({ emoji: EMOJI[code] });
      run = '';
      i += code.length - 1;
    } else run += text[i];
  }
  if (run) parts.push(run);
  return parts;
}
